export enum MessageRequestTypes {
    MailStartupData = 'GetMailStartupData',
    MiniContentRendered = 'MiniContentRendered',
    PushSubscriptionData = 'PushSubscriptionData',
    GetDeviceGUID = 'GetDeviceGUID',
    SetLastURL = 'SetLastURL',
    OpenDownloadURL = 'OpenDownloadURL',
    DisableNotification = 'DisableNotification',
}
